import { render } from "./info-text.vue?vue&type=template&id=56eb245a&scoped=true"
import script from "./info-text.vue?vue&type=script&lang=js"
export * from "./info-text.vue?vue&type=script&lang=js"

import "./info-text.vue?vue&type=style&index=0&id=56eb245a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56eb245a"]])

export default __exports__